import http from "../../../core/services/http.service";

const ItemLocationService = {
  getItemLocations(params = null) {
    return http.get('/api/v1/branches/item-locations/compact-tree/', {params});
  },
  getItemLocationsQrCodePdf(params) {
    return http.post('/api/v1/branches/item-locations/qr-code-pdf/', params);
  },

  isDescendant(tree, ancestorUUID, descendantUUID, uuidKey = "uuid", childrenKey = "children") {
    if (!Array.isArray(tree)) return false;
    if (ancestorUUID == null || descendantUUID == null) return false;
    if (ancestorUUID === descendantUUID) return false; // change to true if you want "self counts"

    const ancestorNode = this.findNode(tree, ancestorUUID, uuidKey, childrenKey);
    if (!ancestorNode) return false;

    const children = Array.isArray(ancestorNode[childrenKey]) ? ancestorNode[childrenKey] : [];
    return this.containsUUID(children, descendantUUID, uuidKey, childrenKey);
  },
  findNode(nodes, targetUUID, uuidKey, childrenKey) {
    for (const node of nodes) {
      if (node[uuidKey] === targetUUID) return node;
      const children = Array.isArray(node[childrenKey]) ? node[childrenKey] : [];
      const hit = this.findNode(children, targetUUID, uuidKey, childrenKey);
      if (hit) return hit;
    }
    return null;
  },
  containsUUID(nodes, targetUUID, uuidKey, childrenKey) {
    for (const node of nodes) {
      if (node[uuidKey] === targetUUID) return true;
      const children = Array.isArray(node[childrenKey]) ? node[childrenKey] : [];
      if (this.containsUUID(children, targetUUID, uuidKey, childrenKey)) return true;
    }
    return false;
  }
};

export default ItemLocationService;
